/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LinkedAppointmentOptions } from './LinkedAppointmentOptions';
import {
    LinkedAppointmentOptionsFromJSON,
    LinkedAppointmentOptionsFromJSONTyped,
    LinkedAppointmentOptionsToJSON,
} from './LinkedAppointmentOptions';

/**
 * 
 * @export
 * @interface FollowUpConcern
 */
export interface FollowUpConcern {
    /**
     * 
     * @type {string}
     * @memberof FollowUpConcern
     */
    concern_id: string;
    /**
     * 
     * @type {LinkedAppointmentOptions}
     * @memberof FollowUpConcern
     */
    options?: LinkedAppointmentOptions;
    /**
     * 
     * @type {string}
     * @memberof FollowUpConcern
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowUpConcern
     */
    explanation?: string;
}

/**
 * Check if a given object implements the FollowUpConcern interface.
 */
export function instanceOfFollowUpConcern(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "concern_id" in value;

    return isInstance;
}

export function FollowUpConcernFromJSON(json: any): FollowUpConcern {
    return FollowUpConcernFromJSONTyped(json, false);
}

export function FollowUpConcernFromJSONTyped(json: any, ignoreDiscriminator: boolean): FollowUpConcern {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'concern_id': json['concern_id'],
        'options': !exists(json, 'options') ? undefined : LinkedAppointmentOptionsFromJSON(json['options']),
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'explanation': !exists(json, 'explanation') ? undefined : json['explanation'],
    };
}

export function FollowUpConcernToJSON(value?: FollowUpConcern | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'concern_id': value.concern_id,
        'options': LinkedAppointmentOptionsToJSON(value.options),
        'icon': value.icon,
        'explanation': value.explanation,
    };
}

